var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.$store.getters.getClientId,staticClass:"pa-4"},[_c('domain-root',{attrs:{"type":"Client","id":_vm.$store.getters.getClientId,"show-deleted":_vm.showDeleted,"read-only":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }